import React from 'react';
import { ButtonTW } from 'tailwindComponents/buttonTW/ButtonTW';
import { depositCategoryOptions } from 'types/order/escrow/eDepositCategory';
import { payerTypeOptions } from 'types/order/escrow/ePayerType';
import { NumberField, SelectField } from 'ui-toolkit';

export const ExpectedSimpleForm: React.FC = () => (
  <div className={'flex flex-row gap-1 py-4'}>
    <div className={'basis-36'}>
      <NumberField label={'Amount'} name={`amountCents`} mode="currency" placeholder="123,456.78" valueIsCents />
    </div>
    <SelectField name={'payerType'} options={payerTypeOptions} className={'basis-64 text-left'} label={'Payer Type'} />
    <SelectField
      name={'category'}
      options={depositCategoryOptions}
      className={'basis-64 text-left'}
      label={'Category'}
    />
    <div className={'basis-28 self-center'}>
      <ButtonTW type={'submit'} data-test-id={'save-new-expected'}>
        Save
      </ButtonTW>
    </div>
  </div>
);
